import { render, staticRenderFns } from "./BusinessPaymentTableHead.vue?vue&type=template&id=366aa823&"
import script from "./BusinessPaymentTableHead.vue?vue&type=script&lang=js&"
export * from "./BusinessPaymentTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports